export interface ICenterCompliance {
    complianceIssues: string[],
    totalChecks: number,
    failedChecks: number
}